import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

import { RewardsStyleVariant, WithStyleVariant } from '../types';

const RewardsTitleContainer = styled.div<WithStyleVariant>`
  width: 100%;
  margin-bottom: ${primitive.$spacing5};
  margin-top: ${primitive.$spacing5};

  display: flex;
  flex-direction: column;
  font: ${brandFont.headerThree};
  line-height: inherit;
  color: ${({ variant, theme }) =>
    variant === RewardsStyleVariant.Secondary
      ? theme.token('text-reversed')
      : theme.token('text-default')};
`;

const RewardPoints = styled.div`
  color: ${primitive.th.$coffeeBrown};
  font-size: 1.25rem;
`;

const RewardLevel = styled.div`
  color: ${primitive.th.$coffeeBrown};
`;

const RewardCateogoryDropdownHeader: React.FC<{ points?: number } & WithStyleVariant> = ({
  variant = RewardsStyleVariant.Primary,
  points = 0,
}) => {
  const { formatMessage } = useIntl();

  return (
    <RewardsTitleContainer variant={variant} tabIndex={0}>
      <RewardLevel>{formatMessage({ id: 'loyaltyHelp' })}</RewardLevel>
      <RewardPoints data-testid="tim-rewards-loyalty">
        {formatMessage({ id: 'cartLoyaltyPoints' }, { points })}
      </RewardPoints>
    </RewardsTitleContainer>
  );
};

export default RewardCateogoryDropdownHeader;
